
export interface AppUpdate {
  version: string;
  date: string;
  commits: string[];
}

const CURRENT_VERSION = "2.4.0-BETA";

const RECENT_UPDATES: AppUpdate = {
  version: CURRENT_VERSION,
  date: new Date().toLocaleDateString(),
  commits: [
    "feat(social): added global leaderboard and ranking system",
    "feat(vault): implemented public/private profile security protocols",
    "ui: massive cybernetic visual overhaul for social hub",
    "perf: optimized loading sequence with real-time market ticker",
    "fix(scanner): improved optical recognition stability algorithm",
    "feat(auth): google identity services integration complete"
  ]
};

export const systemService = {
  getVersion(): string {
    return CURRENT_VERSION;
  },

  getLatestUpdate(): AppUpdate {
    return RECENT_UPDATES;
  },

  shouldShowOnboarding(): boolean {
    const hasSeen = localStorage.getItem('pokebase_onboarding_complete');
    return !hasSeen;
  },

  completeOnboarding() {
    localStorage.setItem('pokebase_onboarding_complete', 'true');
    // Also set the version so they don't immediately see the changelog
    localStorage.setItem('pokebase_last_version', CURRENT_VERSION);
  },

  shouldShowChangelog(): boolean {
    const lastVersion = localStorage.getItem('pokebase_last_version');
    // Only show if they have finished onboarding AND version mismatch
    const onboardingComplete = localStorage.getItem('pokebase_onboarding_complete');
    
    if (!onboardingComplete) return false; // Priority to onboarding
    return lastVersion !== CURRENT_VERSION;
  },

  ackChangelog() {
    localStorage.setItem('pokebase_last_version', CURRENT_VERSION);
  }
};
